import React from 'react';
import ApprovedAdsContainer from './../../../../Containers/UserContainer/Ads/ApprovedAds/index';

const ApprovedAdsScreen = () => {
  return <ApprovedAdsContainer />;
};

export default ApprovedAdsScreen;
